import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import {
  getOutcome,
  getDatasetFromSetup,
  getDatasetSelection,
  getSelectedFields,
  updateOutcome,
  updateDatasetId,
  updateLabelFromDatasetId,
  updateLabel,
  updateTruePositiveLabel,
  updateTrueNegativeLabel,
  updateFalsePositiveLabel,
  updateFalseNegativeLabel,
  updateIsBlueprint,
  updateIgnored,
  updateIgnoredValue,
  updateSuccess
} from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";
import { handleFileChange, handleOpenUpload } from "containers/Upload/reducer";
import { getTableauDataOptions, getIsTabUploading, handleTableauUpload } from "containers/Login/reducer";
import { getIsDatasetsLoading, getIsDataUploading } from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as transformReducer from "containers/Dataset/reducer";

import ChooseDataset from "components/CreateWizard/Dataset/ChooseDataset";
import DatasetViewContainer from "containers/View/Dataset";
import RecipeViewContainer from "containers/View/Recipe";

const bId = "ChooseDataset";

class ChooseDatasetContainer extends React.PureComponent {
  handleUpdate(selection) {
    const {
      selectedDataset,
      index,
      updateSelection,
      updateLabelFromDatasetId,
      updateStep,
      generateNameAndUpdate,
      blueprintId,
      id
    } = this.props;

    if (selectedDataset === undefined) {
      updateStep(index + 1);
    }

    if (selectedDataset !== undefined && selection !== undefined && selection.value === undefined) {
      updateStep(index);
    }

    return updateSelection(selection).then(() => {
      if (id === "new" && (blueprintId === "template" || blueprintId === "academic"))
        return generateNameAndUpdate(selection.value, blueprintId === "template" ? "Optimized" : "Academic");
    });

    /*
    if (selection && selection.value) {
      updateLabelFromDatasetId(selection.value);
    }
    */
  }

  render() {
    const { step, index, blueprintId, transformUpdateDataset, updateImportRecipeId, updateDeployRecipeId } = this.props;

    return (
      <ChooseDataset
        {...this.props}
        datasetView={
          <DatasetViewContainer blueprintId={blueprintId} onClick={(s) => this.handleUpdate({ value: s })} />
        }
        importRecipeView={
          <RecipeViewContainer
            solutionType="import"
            blueprintId={blueprintId}
            onClick={updateImportRecipeId}
            hideFirst
          />
        }
        deployRecipeView={
          <RecipeViewContainer
            solutionType="writeback"
            blueprintId={blueprintId}
            onClick={updateDeployRecipeId}
            hideFirst
          />
        }
        updateSelection={(selection) => this.handleUpdate(selection)}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSelection: (selection) =>
    dispatch(updateDatasetId(ownProps.id, selection.value, true, ownProps.index, ownProps.blueprintId, true)),
  generateNameAndUpdate: (datasetId, message = "Optimized") =>
    dispatch(setupReducer.generateNameAndUpdate(ownProps.id, datasetId, message)),
  updateOutcome: (outcome) => dispatch(updateOutcome(ownProps.id, outcome)),
  transformUpdateDataset: (dataset) => dispatch(homeReducer.transformUpdateDataset(dataset.id, dataset)),
  updateStep: (step) => dispatch(updateStep(step)),
  handleTableauUpload: (index) => dispatch(handleTableauUpload(index)),
  handleFileChange: (file) => dispatch(handleFileChange(file)),
  fetchNextDatasets: () => dispatch(homeReducer.fetchNextDatasets(undefined, undefined, undefined, undefined, true)),
  updateOpenUploadModal: (isOpen, datasetId) => dispatch(handleOpenUpload(isOpen, datasetId)),
  updateTruePositiveLabel: (useCase) => dispatch(updateTruePositiveLabel(ownProps.id, useCase)),
  updateTrueNegativeLabel: (useCase) => dispatch(updateTrueNegativeLabel(ownProps.id, useCase)),
  updateFalsePositiveLabel: (useCase) => dispatch(updateFalsePositiveLabel(ownProps.id, useCase)),
  updateFalseNegativeLabel: (useCase) => dispatch(updateFalseNegativeLabel(ownProps.id, useCase)),
  updateSuccess: (success) => dispatch(updateSuccess(ownProps.id, success)),
  updateLabel: (label) => dispatch(updateLabel(ownProps.id, label)),
  updateLabelFromDatasetId: (datasetId) => dispatch(updateLabelFromDatasetId(ownProps.id, datasetId)),
  updateIsBlueprint: (isBlueprint) => dispatch(updateIsBlueprint(ownProps.id, isBlueprint)),
  updateImportRecipeId: (recipeId) => dispatch(blueprintReducer.updateImportRecipeId(ownProps.blueprintId, recipeId)),
  updateDeployRecipeId: (recipeId) => dispatch(blueprintReducer.updateDeployRecipeId(ownProps.blueprintId, recipeId)),
  updateIgnored: (column, isIgnored) => dispatch(updateIgnored(ownProps.id, column, isIgnored)),
  updateIgnoredValue: (column, value, isIgnored) => dispatch(updateIgnoredValue(ownProps.id, column, value, isIgnored)),
  updateColumnDescription: (blueprintId, column, description) =>
    dispatch(blueprintReducer.updateColumnDescription(blueprintId, column, description)),

  updateSplitColumn: (column) => dispatch(setupReducer.updateSplitColumn(ownProps.id, column))
});

const mapStateToProps = (state, ownProps) => {
  return {
    selection: getDatasetSelection(state, ownProps.id),
    selectedFields: getSelectedFields(state, ownProps.id),
    datasetOptions: homeReducer.getDatasetOptions(state),
    datasets: [getDatasetFromSetup(state, ownProps.id), homeReducer.getDatasetsArr(state)],
    selectedDataset: getDatasetFromSetup(state, ownProps.id),
    outcome: getOutcome(state, ownProps.id),
    step: getStep(state),
    tableauData: getTableauDataOptions(state),
    isTabUploading: getIsTabUploading(state),
    isDatasetsLoading: getIsDatasetsLoading(state),
    isDataUploading: getIsDataUploading(state),
    originalDataset: blueprintReducer.getOriginalDataset(state, ownProps.blueprintId),
    columnDescription: blueprintReducer.getAllColumnDescription(state, ownProps.blueprintId),
    ignored: setupReducer.getIgnored(state, ownProps.id),

    isEditBlueprint:
      (ownProps.id === "new" && ownProps.blueprintId === "new") ||
      blueprintReducer.getIsEditing(state, ownProps.blueprintId),

    splitColumn: setupReducer.getSplitColumn(state, ownProps.id),
    splitOptions: setupReducer.getSplitOptions(state, ownProps.id),

    importRecipeId: blueprintReducer.getImportRecipeId(state, ownProps.blueprintId),
    deployRecipeId: blueprintReducer.getDeployRecipeId(state, ownProps.blueprintId),
    transformed: transformReducer.getTransformArr(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ChooseDatasetContainer);
